import React from "react";
import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from '../../axios/axiosconf';
import Header from "./Header";
import Aside from "./Aside";
import Footer from "./Footer";
import Loading from "./Loading";

function Indicadores() {
    const [loggedIn, setLoggedIn] = useState(false);
    const [userPermissions, setUserPermissions] = useState([]);
    const [oldPermissions, setOldPermissions] = useState([]);
    const [client, setClient] = useState([]);

    const hasPermission = (permissionSlug) => {
        const checkNew = userPermissions.some(permission => permission.slug === permissionSlug);
        if (checkNew) return true;
        return oldPermissions.includes(permissionSlug);
    };

    useEffect(() => {
        if (!localStorage.getItem('userdata')) {
            setLoggedIn(true);
            return;
        }

        const userdata = JSON.parse(localStorage.getItem('userdata'));

        if (userdata.permissions && Array.isArray(userdata.permissions)) {
            setUserPermissions(userdata.permissions);
        }

        if (userdata.up && Array.isArray(userdata.up)) {
            setOldPermissions(userdata.up);
        }

        axios.get('/get-client?uid=' + userdata.user_id)
            .then(response => {
                if (response.status === 200) {
                    setClient(response.data);
                }
                setLoggedIn(true);
            })
            .catch(() => {
                setLoggedIn(true);
            });
    }, []);

    if (loggedIn) {
        return (
            <div className="wrapper hold-transition" style={{ fontSize: '13px' }}>
                <Header client={client} />
                <Aside client={client} activelink="indicators" />

                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-12">
                                    <ol className="breadcrumb float-sm-left mb-0">
                                        <li className="breadcrumb-item"><Link to="/home">Home</Link></li>
                                        <li className="breadcrumb-item active">Indicadores</li>
                                    </ol>
                                </div>
                            </div>
                            <div className="row mb-2 align-items-end">
                                <div className="col-md-8">
                                    <div className="dash-wrap">
                                        <h1 className="dash-title">Indicadores</h1>
                                        <p className="dash-subtitle mb-0">RIPS, convenios, registros ambientales y notas</p>
                                    </div>
                                </div>
                                <div className="col-md-4 mt-2 mt-md-0 text-md-right">
                                    <Link to="/home" className="btn btn-outline-secondary btn-sm" style={{ borderRadius: '10px', fontWeight: 600 }}>
                                        <i className="fas fa-arrow-left mr-1"></i> Volver al inicio
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>

                    <section className="content">
                        <div className="container-fluid">
                            <div className="dash-card mb-4">
                                <div className="dash-card-header">
                                    <h2 className="dash-card-title">
                                        <span className="title-icon" aria-hidden="true"><i className="fas fa-chart-line"></i></span>
                                        Módulos
                                    </h2>
                                </div>
                                <div className="dash-card-body">
                                    <div className="quick-grid">
                                        {hasPermission('ripsPaciente') && (
                                            <Link to="/administrar-servicios-rips" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-clipboard-list"></i></div>
                                                <p className="quick-title">Plantillas RIPS</p>
                                                <p className="quick-sub">CUPS y plantillas de consulta/procedimiento</p>
                                            </Link>
                                        )}

                                        {hasPermission('administrarRips') && (
                                            <Link to="/listado-rips" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-file-medical"></i></div>
                                                <p className="quick-title">RIPS</p>
                                                <p className="quick-sub">Listado y Gestión de RIPS</p>
                                            </Link>
                                        )}

                                        {hasPermission('administrarRips') && (
                                            <Link to="/rips-convenios" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-file-invoice-dollar"></i></div>
                                                <p className="quick-title">RIPS Convenios</p>
                                                <p className="quick-sub">Generar Facturas desde Convenios</p>
                                            </Link>
                                        )}

                                        {hasPermission('gestionarTemperaturaHumedad') && (
                                            <Link to="/registros-temperatura-humedad" className="quick-card">
                                                <div className="quick-ico"><i className="fas fa-thermometer-half"></i></div>
                                                <p className="quick-title">Temperatura y humedad</p>
                                                <p className="quick-sub">Registros Ambientales</p>
                                            </Link>
                                        )}

                                        <Link to="/administrar-notas" className="quick-card quick-card--notas">
                                            <div className="quick-ico"><i className="fas fa-sticky-note"></i></div>
                                            <p className="quick-title">Notas</p>
                                            <p className="quick-sub">Notas y Recordatorios</p>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>

                <Footer showToast={false} delay={0} />
            </div>
        );
    }

    return (
        <Loading />
    );
}

export default Indicadores;
